import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShieldCheckmarkOutline = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "icon / ionicons / outline / shield-checkmark-outline",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Vector (Stroke)",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M13.5341 6.40245C13.795 6.62836 13.8235 7.02307 13.5975 7.28405L9.26942 12.284C9.15656 12.4144 8.99485 12.4924 8.82255 12.4995C8.65025 12.5066 8.48268 12.4421 8.35949 12.3215L6.43762 10.4386C6.19105 10.1971 6.18699 9.80138 6.42854 9.5548C6.6701 9.30823 7.06581 9.30417 7.31238 9.54573L8.7594 10.9633L12.6525 6.46595C12.8784 6.20497 13.2731 6.17654 13.5341 6.40245Z",
			fill: "white"
		}), /* @__PURE__ */ _jsx("path", {
			id: "Vector (Stroke)_2",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.74294 1.30539C9.90648 1.23154 10.0939 1.23154 10.2574 1.30539C13.3648 2.70872 14.7597 3.15708 18.2004 3.77427C18.4837 3.82509 18.6957 4.06283 18.7138 4.3501C19.3743 14.8194 10.8781 18.4452 10.2337 18.7048C10.0839 18.7651 9.91651 18.7651 9.7667 18.7048C9.12222 18.4452 0.626032 14.8194 1.28658 4.3501C1.3047 4.06283 1.51667 3.82509 1.79999 3.77427C5.2407 3.15708 6.6356 2.70872 9.74294 1.30539ZM2.5103 4.91534C2.21561 13.4424 8.60729 16.8128 10.0002 17.4445C11.3931 16.8128 17.7848 13.4424 17.4901 4.91534C14.3808 4.33812 12.8768 3.84928 10.0002 2.56034C7.12354 3.84928 5.61961 4.33812 2.5103 4.91534Z",
			fill: "white"
		})]
	})
});
export default SvgShieldCheckmarkOutline;
